import React, { useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { isEmpty } from 'lodash'
import useToastContext from 'hooks/useToastContext'
import { AiFillEdit, AiFillDelete } from 'react-icons/ai'
import { BsFillPlayCircleFill, BsArrowUpShort } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import helper from '../../utils/helpers'
import { Link, NavLink } from 'react-router-dom'
import DesView from "./descriptionViewModal";

const Table = ({
  tutorials,
  getAllTutorials,
  user,
  page,
  sort,
  setSort,
  manager
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [description, setDescription] = useState('')
  const [viewDesShowModal, setViewDesShowModal] = useState(false)

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.tutorialChangeStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllTutorials()
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handelDelete = async (item) => {
    try {
      const path = apiPath.tutorialDelete + "/" + item?._id;
      const result = await apiPut(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllTutorials()
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  const handleDescriptionView = (item) => {
    setDescription(item)
    setViewDesShowModal(true)
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full text-sm text-left text-[#4d4c4c] dark:text-gray-400 '>
          <thead className='text-sm text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-2'>
                #
              </th>
              <th
                scope='col'
                className='py-3 px-2'
              >
                <div className='flex '>
                  <span>{t('O_TITLE')} </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-2'
              >
                <div className='flex '>
                  <span>{t('O_DESCRIPTION')} </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-2 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')}</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              
              {(manager?.add || user?.role === 'admin') && (
                <th scope='col' className='py-3 px-2 text-center'>
                  {t('O_STATUS')}
                </th>
              )}
              <th scope='col' className='py-3 px-2 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {tutorials &&
                tutorials?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>
                    {item?.title}
                  </td>
                  <td className='py-2 px-2 border-r text-left break-all'>
                    {(item?.description).slice(0,50)}{item?.description?.length > 50 && <span className='text-black cursor-pointer' onClick={()=> handleDescriptionView(item?.description)}> {t('O_READ_MORE')}</span>}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } ${item.title}`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                      <>
                            <li className='px-2 py-2  hover:text-red-500 text-LightBlue'>
                              <a
                                href={item?.video}
                                title={t('O_PLAY')}
                                target='_blank' rel="noreferrer"
                              >
                                <BsFillPlayCircleFill className='cursor-pointer w-5 h-5 text-slate-600' />
                              </a>
                            </li>
                          </>
                          {(manager?.add || user?.role === "admin") && (
                          <Link
                            title={t('O_EDIT_EDIT')}
                            className=" px-2 py-2 text-danger"
                            to="/tutorials/edit-tutorial"
                            state={{ ...item }}
                          >
                            <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                          </Link>
                        )}
                          <>
                            <li className='px-2 py-2'>
                              <NavLink
                                title={t('O_DELETE')}
                                state={{ item }}
                                onClick={(e) =>
                              helper.alertFunction(
                                `${t('ARE_YOU_SURE_TO_DELETE_TUTORIAL')}`,
                                item,
                                handelDelete,
                                true
                              )
                            }
                              >
                                <AiFillDelete className='cursor-pointer w-5 h-5 text-slate-600' />
                              </NavLink>
                            </li>
                          </>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(tutorials) ? (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-2 px-2 border-r' colSpan={8}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      {viewDesShowModal ? (
        <DesView
          setViewDesShowModal={setViewDesShowModal}
          description={description}
        />
      ) : null}
    </div>
  )
}

export default Table
